export const blockIconsAudioandvideoPlayArrowNew = (
	<span className='material-symbols-outlined'>play_arrow</span>
);
